import React, { memo } from 'react';
import { FilterViewModelDiscriminator, type ProductListResultViewModel } from 'autogen/swagger/all';
import BooleanFilterMenu from './BooleanFilter/BooleanFilterMenu';
import BooleanStarFilterMenu from './BooleanStarFilter/BooleanStarFilterMenu';
import BrandFilterMenuLazy from './BrandFilter/BrandFilterMenuLazy';
import ColorFilterMenu from './ColorFilter/ColorFilterMenu';
import LinkFilterMenu from './LinkFilter/LinkFilterMenu';
import PriceFilterMenu from './PriceFilter/PriceFilterMenu';

const FilterMenu = ({ model }: { model: ProductListResultViewModel['filters'][0] }) =>
    FilterViewModelDiscriminator(
        model,
        (priceModel) => <PriceFilterMenu model={priceModel} />,
        (brandModel) => <BrandFilterMenuLazy model={brandModel} />, // Brand (lazy + gated with fallback)
        (boolModel) => <BooleanFilterMenu model={boolModel} />,
        (boolStarModel) => <BooleanStarFilterMenu model={boolStarModel} />,
        () => null, // Range filter not used currently
        (colorModel) => <ColorFilterMenu model={colorModel} />,
        (linkModel) => <LinkFilterMenu model={linkModel} />,
        () => null
    );

export default memo(FilterMenu);
